import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})

export class FeaturesService {
  
  constructor(private http: HttpClient) { }

  getFeaturesInVersion() {
    return this.http.get("assets/features/featuresInVersion.json");
  }
}
